import { toaster } from '@/components';
import { trans } from '@/i18n';

export const showError = (payload: string | any = 'shared.error') => {
  let message = payload;
  if (typeof payload !== 'string') {
    if (typeof payload?.response?.data?.message === 'string') {
      message = payload?.response?.data?.message;
    } else if (typeof payload?.response?.data?.message === 'object') {
      message = payload?.response?.data?.message[0];
    } else {
      message = payload?.message || trans('shared.error');
    }
  }
  toaster.create({
    title: trans(message),
    type: 'error',
  });
};

export const showSuccess = (message: string = 'shared.success') => {
  toaster.create({
    title: trans(message),
    type: 'success',
  });
};
